import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SettingsCtx = createContext({ ads: {} });

export function SettingsProvider({ children }) {
  const [s, setS] = useState({ ads: {} });
  useEffect(() => {
    api.get("/settings").then((r) => setS({ ads: {}, ...(r.data || {}) })).catch(() => {});
  }, []);
  return <SettingsCtx.Provider value={s}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);

export function useApi(path, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState((p) => ({ ...p, loading: true }));
    api
      .get(path)
      .then((r) => alive && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => alive && setState({ data: null, loading: false, error: e }));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}

export { useSeo } from "./seo";
